var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nothing-here-block"},[_vm._v("\n  "+_vm._s(_vm.__('This diff was suppressed by a .gitattributes entry.'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }